import { mediaQuery } from "oolib";
import styled from "styled-components";

export const LandingCompContainerStyled = styled.div`
  position: relative;
  bottom: 0;

  ${mediaQuery("sm")} {
    position: absolute;
    bottom: 0;
  }
`;
